<template>
    <b-card no-body :header="$t('com_user', { ns: 'common' })">
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>
        <div>
            <!-- maak / toon groep -->
            <b-form-group class="form-inline">
                <b-form-input
                    id="display-naam"
                    :placeholder="$t('com_naam', { ns: 'common' })"
                    v-model="displayNaam"
                    :state="checkName"
                ></b-form-input>
                <b-form-input
                    id="gebruikers-naam"
                    :placeholder="
                        $t('com_gebruikersnaam', {
                            ns: 'common'
                        })
                    "
                    v-model="gebruikersNaam"
                ></b-form-input>
                <b-form-input
                    id="gebruikers-mail"
                    :placeholder="
                        $t('com_mail', {
                            ns: 'common'
                        })
                    "
                    v-model="gebruikersMail"
                ></b-form-input>
                <b-button
                    v-if="checkRight('UserCreate') && checkUserLicenses"
                    @click="addNewGebruiker()"
                    class="bgc_aux_normal"
                    ><font-awesome-icon icon="arrow-down" size="1x" />
                </b-button>
                &nbsp;
                <b-button @click="getOperators()" class="bgc_aux_normal"
                    ><font-awesome-icon icon="sync" size="1x" />&nbsp;{{
                        $t('com_refresh', { ns: 'common' })
                    }}
                </b-button>
            </b-form-group>
            <b-table
                :items="operatorList"
                :fields="gebruikers"
                stacked="md"
                show-empty
                :empty-text="$t('com_geen_data', { ns: 'common' })"
                small
                striped
                @row-clicked="toonDetail"
            >
                <template v-slot:cell(actions)="row">
                    <div class="form-inline">
                        <b-button
                            v-if="checkRight('UserDelete')"
                            size="sm"
                            @click="verwijderItem(row.item)"
                            class="bgc_aux_alarm"
                            ><font-awesome-icon icon="trash-alt" size="1x" />
                        </b-button>
                        <b-button
                            size="sm"
                            @click="toonDetail(row.item)"
                            class="bgc_aux_unknown"
                            ><font-awesome-icon icon="info-circle" size="1x" />
                        </b-button>
                    </div>
                </template>
                <template v-slot:row-details>
                    <div v-if="filteredGroupList.length > 0">
                        <b-table
                            :items="filteredGroupList"
                            :fields="groepen"
                            stacked="md"
                            show-empty
                            :empty-text="$t('com_geen_data', { ns: 'common' })"
                            small
                            striped
                        >
                        </b-table>
                    </div>
                    <div v-else class="form-inline">
                        <b-column cols="4">
                            <b-form-checkbox-group
                                v-model="detailPermissions"
                                :options="detailPermissionList"
                                class="mb-3"
                                value-field="id"
                                text-field="naam"
                                stacked
                                @change="setChecked"
                            ></b-form-checkbox-group>
                        </b-column>
                        <!-- <b-column cols="4"> <label>{{ constURLuitpekelDashboard }}</label> </b-column>
                        <b-column cols="4"> </b-column> -->
                    </div>
                </template>
            </b-table>
            <br />
        </div>
    </b-card>
</template>

<script>
import { loadItem, loadList } from '@/models/DataHelper';
import { Permission } from '../../models/Permissions';
export default {
    name: 'CardGebruikers',
    data() {
        return {
            constURLuitpekelDashboard: '/productie/uitpekelen/dashboard',
            constDashboard: 'Dashboard',
            showDismissibleAlert: false,
            detailPermissions: null,
            detailPermissionList: [],
            permissionList: [],
            alertText: '',
            operatorList: [],
            gebruikersNaam: null,
            displayNaam: null,
            gebruikersMail: null,
            selectedOperator: null,
            forceRefresh: true,
            userlicenses: 1,
            gebruikers: [
                { key: 'actions', label: ' ' },
                {
                    key: 'naam',
                    label: this.$t('com_gebruikersnaam', {
                        ns: 'common'
                    }),
                    sortable: true
                },
                {
                    key: 'mail',
                    label: this.$t('com_mail', {
                        ns: 'common'
                    }),
                    sortable: true
                },
                {
                    key: 'login',
                    label: this.$t('com_login', {
                        ns: 'common'
                    }),
                    sortable: true
                }
            ],
            groepen: [
                {
                    key: 'groupname',
                    label: this.$t('com_groep', {
                        ns: 'common'
                    }),
                    sortable: true
                }
            ]
        };
    },
    props: {},
    computed: {
        selectedUserName() {
            return this.selectedOperator ? this.selectedOperator.naam : '';
        },
        filteredGroupList() {
            const thisid = this.selectedOperator
                ? this.selectedOperator.id
                : -1;
            return this.$store.getters['account/getUserInGroups'](thisid);
        },
        dashboardList() {
            return this.$store.getters['account/getGroupUsers'](
                this.constDashboard
            );
        },
        checkUserLicenses() {
            const useramount = this.operatorList.length;
            return this.userlicenses > useramount ? true : false;
        },
        checkName() {
            return this.displayNaam && this.displayNaam.length > 2
                ? true
                : false;
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        async toonDetail(item) {
            this.selectedOperator = item;
            if (item._showDetails) {
                this.$set(item, '_showDetails', false);
            } else {
                this.operatorList.forEach((item) => {
                    this.$set(item, '_showDetails', false);
                });

                if (this.filteredGroupList.length == 0) {
                    if (this.permissionList.length > 0) {
                        this.detailPermissionList = this.permissionList.filter(
                            (x) => x.onderdeel == this.constDashboard
                        );
                        // filter de geselecteerd permissies
                        const magLijst = [];
                        const selectionData = {
                            userid: this.selectedOperator.id
                        };
                        const locList = await loadItem(
                            'account/loadUserPermissions',
                            selectionData,
                            this.$t
                        );
                        for (
                            let i = 0;
                            i < this.detailPermissionList.length;
                            i++
                        ) {
                            const id = this.detailPermissionList[i].id;
                            // haal rechten op, zitten niet in selectedoperator
                            const test = locList.find((x) => x.id === id);
                            if (test) magLijst.push(test.id);
                        }
                        this.detailPermissions = magLijst;
                    }
                }

                this.$set(item, '_showDetails', true);
            }
        },
        async setChecked(checked) {
            const token = await loadItem('extern/generateToken', null, this.$t);
            const UserPermissionsModel = {
                UserID: this.selectedOperator.id,
                Token: token,
                PermissionIDs: this.detailPermissions
            };
            loadItem(
                'gebruiker/saveUserPermissions',
                UserPermissionsModel,
                this.$t
            );
        },
        async verwijderItem(item) {
            let result = rtue;
            const doClose = await this.$root.showConfirmationBox(
                this.$t('com_delete', {
                    ns: 'common',
                    val: this.$t('com_gebruikersnaam', { ns: 'common' })
                }) + item.naam
            );
            if (doClose) {
                const selectionData = {
                    userid: item.id
                };
                result = await loadItem(
                    'gebruiker/deleteUser',
                    selectionData,
                    this.$t
                );
                if (!result) {
                    this.showAlert(  this.$t('com_errorverwijder', { ns: 'common' })  );
                    return result;
                }
                await this.getOperators();
            }
            this.loadUserLicenses();
            return result;
        },
        async addNewGebruiker() {
            if (this.checkValid()) {
                const RegisterUserModel = {
                    Email: this.gebruikersMail,
                    Username: this.gebruikersNaam,
                    DisplayName: this.displayNaam
                };
                await loadItem(
                    'gebruiker/createUser',
                    RegisterUserModel,
                    this.$t
                );
                await this.getOperators();
                this.gebruikersMail = null;
                this.gebruikersNaam = null;
            }
        },
        checkRight(recht) {
            const id = Permission.enum(recht);
            return this.$root.handleRight(id);
        },
        async getOperators() {
            this.operatorList = await loadList(
                'account/getOperators',
                'account/loadOperators',
                null,
                this.forceRefresh,
                this.$t
            );
        },
        async loadUserLicenses() {
            const lijst = await loadList(
                'masterdata/getConstantsLijst',
                'masterdata/loadApplicationConstants',
                null,
                this.forceRefresh,
                this.$t
            );
            const con = lijst
                ? lijst.find((x) => x.text == window.constants.APPCONST_MAXUSER)
                : null;
            this.aantal = con ? con.value : 1;
            this.userlicenses = this.aantal;
        },
        checkValid() {
            let result = true;
            if (!this.displayNaam) {
                this.showAlert(
                    this.$t('com_isrequired', {
                        ns: 'common',
                        val: '',
                        prop: this.$t('com_naam', { ns: 'common' })
                    })
                );
                result = false;
            }
            if (this.gebruikersNaam && this.gebruikersMail) {
                this.showAlert(this.$t('com_warnemailuser', { ns: 'common' }));
                result = false;
            }
            return result;
        }
    },
    async mounted() {
        this.loadUserLicenses();
    },
    async created() {
        this.getOperators();
        this.permissionList = await loadList(
            'account/getPackagePermissions',
            'account/loadPackagePermissions',
            null,
            this.forceRefresh,
            this.$t
        );
    }
};
</script>

